import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-601a4c14"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml50 mt20 mr50 pb50"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "发票详情 ", -1));
const _hoisted_3 = {
  class: "sub_title text_grey mt15 mb15 flex_FSBC"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sub_title bold mt15"
}, "开票信息", -1));
const _hoisted_5 = {
  class: "open_invice_info flex_FSBC mt15 mb30"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_size_1"
}, [/*#__PURE__*/_createElementVNode("p", null, "开票方"), /*#__PURE__*/_createElementVNode("p", null, "受票方"), /*#__PURE__*/_createElementVNode("p", null, "开户行"), /*#__PURE__*/_createElementVNode("p", null, "应税地"), /*#__PURE__*/_createElementVNode("p", null, "发票项目"), /*#__PURE__*/_createElementVNode("p", null, "开票日期"), /*#__PURE__*/_createElementVNode("p", null, "数量")], -1));
const _hoisted_7 = {
  class: "flex_size_1"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_size_1"
}, [/*#__PURE__*/_createElementVNode("p", null, "身份证号"), /*#__PURE__*/_createElementVNode("p", null, "受方税号"), /*#__PURE__*/_createElementVNode("p", null, "账户号"), /*#__PURE__*/_createElementVNode("p", null, "地址"), /*#__PURE__*/_createElementVNode("p", null, "开票含税金额（元）"), /*#__PURE__*/_createElementVNode("p", null, "单位"), /*#__PURE__*/_createElementVNode("p", null, "ㅤ")], -1));
const _hoisted_9 = {
  class: "flex_size_1"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ㅤ", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "sub_title"
}, "运单明细 ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table = _resolveComponent("el-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, "发票申请号：" + _toDisplayString($setup.data.invoiceNo), 1), _createElementVNode("p", null, "发票号： " + _toDisplayString($setup.data.invoiceCode), 1), _createElementVNode("p", null, "开票状态： " + _toDisplayString($setup.invoiceSuccessList[$setup.data.invoiceStatus]), 1)]), _createVNode(_component_el_button, {
    type: "success",
    disabled: $setup.data.invoicePdfUrl,
    onClick: _cache[0] || (_cache[0] = () => $setup.download())
  }, {
    default: _withCtx(() => [_createTextVNode("下载发票")]),
    _: 1
  }, 8, ["disabled"]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString($setup.data.invoiceMaker), 1), _createElementVNode("p", null, _toDisplayString($setup.data.invoiceReceiver), 1), _createElementVNode("p", null, _toDisplayString($setup.data.openBank), 1), _createElementVNode("p", null, _toDisplayString($setup.data.taxableAddress), 1), _createElementVNode("p", null, _toDisplayString($setup.data.invoiceItems), 1), _createElementVNode("p", null, _toDisplayString($setup.moment($setup.data.applyTime).format("YYYY-MM-DD HH:mm")), 1), _createElementVNode("p", null, _toDisplayString($setup.data.number), 1)]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString($setup.data.driverIdentityNumber), 1), _createElementVNode("p", null, _toDisplayString($setup.data.taxNo), 1), _createElementVNode("p", null, _toDisplayString($setup.data.bankNo), 1), _createElementVNode("p", null, _toDisplayString($setup.data.workAddress), 1), _createElementVNode("p", null, _toDisplayString($setup.data.invoiceAmount / 100), 1), _createElementVNode("p", null, _toDisplayString($setup.data.unit), 1), _hoisted_10])]), _hoisted_11, _createVNode(_component_el_table, {
    height: "400",
    data: $setup.data.orderList,
    class: "mt15",
    "show-overflow-tooltip": "true"
  }, {
    empty: _withCtx(() => [_createVNode(_component_el_empty, {
      description: "暂无数据"
    })]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "loadingAddress",
      label: "装货地"
    }), _createVNode(_component_el_table_column, {
      prop: "unloadingAddress",
      label: "卸货地"
    }), _createVNode(_component_el_table_column, {
      prop: "transport",
      label: "运输工具"
    }), _createVNode(_component_el_table_column, {
      prop: "vehicleNo",
      label: "车牌号"
    }), _createVNode(_component_el_table_column, {
      prop: "vehicleType",
      label: "车辆种类"
    }), _createVNode(_component_el_table_column, {
      prop: "goodsName",
      label: "货物名称"
    })]),
    _: 1
  }, 8, ["data"])]);
}